
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"d":"M9.42 7.07c.113 0 .113 0 0 0 .113-.454.227-.681.227-1.022v-.227c.113-.567.113-1.021 0-1.134v-.114l-.114-.113s0 .113-.113.113c-.227.681-.227 1.475 0 2.497zM6.015 14.9c-.227.114-.454.228-.567.341-.795.681-1.362 1.476-1.476 1.816.681-.113 1.362-.794 2.043-2.156.114 0 .114 0 0 0 .114 0 0 0 0 0zm10.441-1.702c-.113-.113-.567-.454-2.156-.454h-.227v.114c.794.34 1.589.567 2.156.567h.341v-.113s-.114 0-.114-.114zM18.16.714H2.269A2.277 2.277 0 000 2.984v15.889a2.277 2.277 0 002.27 2.27h15.889a2.277 2.277 0 002.27-2.27V2.984a2.277 2.277 0 00-2.27-2.27zM16.91 14.106a2.266 2.266 0 01-1.021.227c-.908 0-2.27-.227-3.405-.794-1.93.227-3.405.454-4.54.908-.113 0-.113 0-.227.113-1.361 2.384-2.496 3.519-3.404 3.519-.227 0-.34 0-.454-.114l-.568-.34v-.114c-.113-.227-.113-.34-.113-.567.113-.568.794-1.59 2.156-2.384.227-.113.568-.34 1.022-.567.34-.568.68-1.249 1.134-2.043.568-1.135.908-2.27 1.249-3.291-.454-1.362-.681-2.157-.227-3.746.113-.453.454-.907.908-.907h.227c.227 0 .454.113.68.227.795.794.455 2.61 0 4.085v.114c.455 1.248 1.136 2.27 1.817 2.95.34.228.567.454 1.021.681.568 0 1.021-.113 1.475-.113 1.362 0 2.27.227 2.61.794.114.227.114.454.114.681-.113.114-.227.454-.454.681zM9.533 9.68c-.227.795-.68 1.703-1.135 2.724-.227.454-.454.794-.68 1.248h.226c1.476-.567 2.838-.908 3.746-1.021-.227-.114-.34-.227-.454-.34-.568-.681-1.249-1.59-1.703-2.61z","fill":"#4E6492"}})])])
          )
        }
      }
    